import React, { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { CardsWidgetPlanDetails } from '../../../_metronic/partials/widgets/_new/cards/CardsWidgetPlanDetails'
import { CardsWidgetSMSDetails } from '../../../_metronic/partials/widgets/_new/cards/CardsWidgetSMSDetails'
import { ChartsWidgetVerdictBifurcationStacked } from '../../../_metronic/partials/widgets/_new/charts/ChartsWidgetVerdictBifurcationStacked'
import { useSearchParams, useLocation } from 'react-router-dom'
import { axiosClientAuth } from '../../utils'
import dayjs from 'dayjs'

const OperatorSummary = () => {
  const [searchParams] = useSearchParams()
  const { state: navState } = useLocation() as { state: { name?: string; pe_id?: string } | null }
  const [analyticsData, setAnalyticsData] = useState<any>(null)
  const [smsData, setSmsData] = useState<any>(null)

  useEffect(() => {
    axiosClientAuth
      .get('/analytics/resources/', { params: { owner_id: searchParams.get('user') } })
      .then((res) => setAnalyticsData(res.data.data))
      .catch((err) => console.log(err))
  }, [])

  useEffect(() => {
    const ownerId = searchParams.get('user')
    axiosClientAuth
      .get('/analytics/operator-stats/', {
        params: {
          owner_id: ownerId,
          from_date: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
          to_date: dayjs().format('YYYY-MM-DD'),
        },
      })
      .then((res) => {
        const results: any[] = res.data.data?.results ?? []
        setSmsData({
          total_message: results.reduce((a, r) => a + (r.total_billable ?? 0), 0),
          success_message: results.reduce((a, r) => a + (r.success_billable ?? 0), 0),
          failed_message: results.reduce((a, r) => a + (r.failed_billable ?? 0), 0),
        })
      })
      .catch((err) => console.log(err))
  }, [])

  const operatorChartData = analyticsData
    ? Object.entries(analyticsData.url.by_operator).map(([key, val]: [string, any]) => ({
        operator: key,
        whitelisted: val.whitelisted,
        blacklisted: val.blacklisted,
        pending: val.pending,
      }))
    : undefined

  return (
    <>
      {/* <div className='d-flex justify-content-end mb-4 align-items-center'>
        <button
          className='btn btn-primary px-20'
          onClick={() => setShow(true)}
        >
          Login As PE
        </button>
      </div> */}
      <div className='row g-5 g-xl-10 mb-xl-10 '>
        <div className='col-5 mb-md-5 mb-xl-10 d-flex flex-column h-100'>
          <CardsWidgetPlanDetails
            className='flex-1 mb-5'
            description='Plan Details'
            color='#F1416C'
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
            data={{ name: navState?.name, pe_id: navState?.pe_id || searchParams.get('user') }}
          />
          <CardsWidgetSMSDetails data={smsData} className='flex-1' />
        </div>
      
        <div className='col-7 mb-md-5 mb-xl-10'>
          <ChartsWidgetVerdictBifurcationStacked
            className='h-100 mb-5 mb-xl-10'
            operatorData={operatorChartData}
            totalCount={analyticsData?.url?.total}
            scanPending={analyticsData?.url?.scan_pending}
            scanFailed={analyticsData?.url?.scan_failed}
          />
        </div>
        {/* <ChartsWidget1 className='' /> */}
        {/* <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
          <ListsWidgetIPHighlight className='h-100 mb-5 mb-xl-10' />
        </div> */}
      </div>

    </>
  )
}

const myBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Account Statistics',
    path: '/operatordata',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const OperatorSummaryWrapper: FC = () => {
  const intl = useIntl()

  return (
    <>
      <PageTitle breadcrumbs={myBreadCrumbs}>
        {/* {intl.formatMessage({ id: 'Account Summary' })} */}
        Account Summary
      </PageTitle>
      <OperatorSummary />
    </>
  )
}

export default OperatorSummaryWrapper
